<ng-container *ngIf="url">
  <a [href]="href" target="_blank" rel="noopener noreferrer" class="doc-link" [ngbTooltip]="tooltip" placement="top" container="body" aria-label="Clique para acessar a documentação">
    <button class="btn btn-sm btn-flat-primary waves-effect no-dropdown-toggle-icon no-boxshadow" type="button">
      <i class="feather icon-info" aria-hidden="true"></i>
    </button>
  </a>
</ng-container>
